"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVER_TRPC_BASE_PATH = exports.NEXT_REVALIDATION_ROUTE = void 0;
exports.NEXT_REVALIDATION_ROUTE = "/api/revalidate";
exports.SERVER_TRPC_BASE_PATH = "/_new/trpc";
